import { Pipe, PipeTransform } from '@angular/core';

/**
 * Форматирует телефон
 * Input: '79876543210' | sdPhoneFormat
 * Output: '+7 987 654 32 10'
 */
@Pipe({
  name: 'sdPhoneFormat',
  standalone: true,
})
export class PhoneFormatPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }
    const onlyDigits = value.replace(/\D+/gm, '');
    const regex = /(^8|7|\+7)*(\d{3})(\d{3})(\d{2})(\d{2})/gm;
    const subst = `+7 $2 $3 $4 $5`;

    return onlyDigits.replace(regex, subst);
  }
}
